import { DraggableAttributes, DraggableSyntheticListeners } from "@dnd-kit/core"
import { CARD_BORDER_RADIUS, RESIZE_HANDLE_HEIGHT } from "./weekViewCardStyles"

type Props = {
  setNodeRef: (node: HTMLElement | null) => void
  listeners: DraggableSyntheticListeners
  attributes: DraggableAttributes
  color: string
}

const WeekViewCardResizeHandle = ({ setNodeRef, listeners, attributes, color }: Props) => (
  <div
    ref={setNodeRef}
    {...listeners}
    {...attributes}
    style={{
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: RESIZE_HANDLE_HEIGHT,
      cursor: 'ns-resize',
      borderBottomLeftRadius: CARD_BORDER_RADIUS,
      borderBottomRightRadius: CARD_BORDER_RADIUS,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <div
      style={{
        width: 24,
        height: 3,
        backgroundColor: color,
        borderRadius: 2,
      }}
    />
  </div>
)

export default WeekViewCardResizeHandle
